import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'chart.js'
import React from 'react'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const ReferralChart = (data: any) => {
  const dataChart = data?.data
  const chartData = {
    labels: [
      'Total Users',
      'Total Users Stake',
      'Total Reward Amount (MEY)',
      'Total Reward Amount (USDC)',
    ],
    datasets: [
      {
        // label: 'Referral Overview',
        data: [
          dataChart?.totalUser,
          dataChart?.totalUserStake,
          dataChart?.totalRewardMey,
          dataChart?.totalRewardUsdc,
        ],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        borderColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        borderWidth: 1,
      },
    ],
  }

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      // title: { display: true, text: 'Staked Overview' },
    },
    scales: {
      y: { beginAtZero: true },
    },
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  )
}

export default ReferralChart
